export default "__VITE_ASSET__2Wz759bx__"